var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content"},[_c('h1',[_vm._v("404")]),_c('div',[_vm._v("Unable to find "+_vm._s(_vm.$route.path))])])}
var staticRenderFns = []

export { render, staticRenderFns }